import { createContext, ReactNode, useContext, useState } from "react";
import { LinkObj, LinkObjs, NestedChoices } from "./types";

export interface Context {
    links: LinkObjs,
    link: LinkObj | null,
    setLink: (link: LinkObj) => void,
    linkChoices: NestedChoices,
    setLinkChoices: (linkChoices: NestedChoices) => void,
}

const DEFAULTCONTEXT: Context = {
    links: [],
    link: null,
    setLink: (_: LinkObj) => { },
    linkChoices: [],
    setLinkChoices: (_: NestedChoices) => { },
};

export const LinkInputContext = createContext<Context>(DEFAULTCONTEXT)

export const useLinkInputContext = () => useContext(LinkInputContext);

interface LinkInputProviderProps {
    links: LinkObjs,
    children: ReactNode,
}

export const LinkInputProvider = ({ children, links, ...rest }: LinkInputProviderProps) => {
    const [link, setLink] = useState<null | LinkObj>(null);
    const [linkChoices, setLinkChoices] = useState<NestedChoices>([]);

    return (
        <LinkInputContext.Provider value={{ links, link, setLink, linkChoices, setLinkChoices, }}>
            {children}
        </LinkInputContext.Provider>
    )
}
